import { useCallback } from "react";
import { Anchor, Button, Group, Paper, Stack, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import type { LegacyPatientCandidate } from "../../../utils/legacyPatientMapping";
import { formatLegacyDate } from "../../../utils/legacyReviewForm";

interface Props {
  candidates: LegacyPatientCandidate[];
  onSelect: (patientId: string) => void;
}

export default function LegacyPatientCandidateList({
  candidates,
  onSelect,
}: Props) {
  const handleSelect = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const id = event.currentTarget.dataset.patientId;
      if (id) onSelect(id);
    },
    [onSelect]
  );
  return (
    <Stack gap="xs">
      {candidates.map((patient) => (
        <Paper
          withBorder
          p="sm"
          key={patient.id}
          style={{ overflowWrap: "anywhere" }}
        >
          <Stack gap={4}>
            <Text fw={600}>
              {patient.lastName}, {patient.firstName}
            </Text>
            <Text size="sm">
              DOB {formatLegacyDate(patient.dateOfBirth)} · Sex {patient.sex} ·
              MRN {patient.medicalRecordNumber || "Not provided"}
            </Text>
            <Text size="xs" c="dimmed">
              {patient.matchReason}
            </Text>
            <Group justify="space-between">
              <Anchor
                component={Link}
                to={`/cases?patientIds=${encodeURIComponent(patient.id)}`}
                target="_blank"
                rel="noopener noreferrer"
                size="sm"
              >
                View this patient's cases
              </Anchor>
              <Button
                variant="light"
                size="xs"
                data-patient-id={patient.id}
                onClick={handleSelect}
              >
                Compare this patient
              </Button>
            </Group>
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
}
